import axios from "axios";
import { AuthorizationRequired } from "src/authorization/auth";
import { notify } from "../Notification/Notification";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
const AUTH_TOKEN = localStorage.getItem("access") || null;
axios.defaults.headers.common["Authorization"] = "Bearer " + AUTH_TOKEN;

export async function get(url, config = {}, signal) {
    return axios
        .get(url, { ...config, signal })  // اضافه کردن سیگنال
        .then((response) => response.data)
        .catch(function (error) {
            if (error.response) {
                const { status } = error?.response;
                const { message } = error?.response?.data;
                if (status === 400) {
                    // Notifications("warning", "filled", "پارامتر های ارسالی را بررسی نمایید.");
                } else if (status === 401) {
                    AuthorizationRequired(message);
                } else if (status === 403) {
                    AuthorizationRequired(message);
                    // PermissionRequired();
                } else {
                    // Notifications("error", "filled", err?.response.data.detail);
                }
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                console.log(error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                if (error.message != "canceled") notify(error.message, "error");
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log("Error", error.message);
            }
        });
}

export async function post(url, data = {}, config = {}) {
    return await axios
        .post(url, data, config)
        .then((response) => response.data)
        .catch(function (error) {
            if (error.response) {
                const { status } = error?.response;
                const { message } = error?.response?.data;
                if (status === 400) {
                    // Notifications("warning", "filled", "پارامتر های ارسالی را بررسی نمایید.");
                } else if (status === 401) {
                    AuthorizationRequired(message);
                } else if (status === 403) {
                    AuthorizationRequired(message);
                    // PermissionRequired();
                } else {
                    // Notifications("error", "filled", err?.response.data.detail);
                }
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                console.log(error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                notify(error.message, "error");
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log("Error", error.message);
            }
        });
}

export async function put(url, data = {}, config = {}) {
    try {
        const response = await axios.put(url, data, config);
        return response.data;
    } catch (error) {
        if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
        } else if (error.request) {
            console.log(error.request);
        } else {
            console.log("Error", error.message);
        }
        console.log(error.config);

        // ❗ این خط بسیار مهمه
        throw error;
    }
}


export async function remove(url, parameters, config = {}) {
    return await axios
        .delete(`${url}?id=${parameters}`, config)
        .then((response) => 200)
        .catch(function (error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log("Error", error.message);
            }
            console.log(error.config);
        });
}